import { useCallback } from "react";
import { useWarmProductInventoryCache } from "@design-lab/entities/product/api/useProductInventoryData";
import { useWarmProductPriceCache } from "@design-lab/entities/product/api/useProductPriceData";

export function useWarmChooseSizesPage() {
  const warmInventoryCache = useWarmProductInventoryCache();
  const warmPriceCache = useWarmProductPriceCache();

  return useCallback(
    (productId: string) => {
      warmInventoryCache(productId);
      warmPriceCache(productId, "print_default");
      warmPriceCache(productId, "print_front_back");
    },
    [warmInventoryCache, warmPriceCache]
  );
}
